'use strict';

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _util = require('../util');

var _constants = require('../constants');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    _root: {},
    center: {
      stroke: '#000'
    },
    text: {
      fontWeight: 'bold',
      fontFamily: theme.fontSecondary,
      textTransform: 'uppercase',
      fill: '#000',
      userSelect: 'none'
    }
  };
};

var BoundingBox = (_dec = (0, _util.withStyles)(styles), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(BoundingBox, _React$Component);

  function BoundingBox() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BoundingBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BoundingBox.__proto__ || Object.getPrototypeOf(BoundingBox)).call.apply(_ref, [this].concat(args))), _this), _this.findLabelPosition = function (points) {
      var defaultPos = {
        x: points[0][0],
        y: points[0][1]
      };
      if (!_this.props.autoPositionLabel) return defaultPos;
      var best = [].concat(_toConsumableArray(points)).sort(function (a, b) {
        return a[0] + a[1] - b[0] - b[1];
      })[0];
      return best ? {
        x: best[0],
        y: best[1]
      } : defaultPos;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BoundingBox, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          color = _props.color,
          hidden = _props.hidden,
          onClick = _props.onClick,
          points = _props.points,
          strokeWidth = _props.strokeWidth,
          fontSize = _props.fontSize,
          showCenter = _props.showCenter,
          shadeBoxes = _props.shadeBoxes,
          closePath = _props.closePath,
          center = _props.center,
          label = _props.label,
          selected = _props.selected,
          i = _props.i,
          id = _props.id,
          style = _props.style,
          pathProps = _props.pathProps,
          classes = _props.classes;
      var boxColor = color || (0, _util.getColor)(_constants.BOX_COLORS, i);
      var showLabel = label && !hidden;
      var labelPos = this.findLabelPosition(points);
      var boxId = id === null ? i : id;
      return _react2["default"].createElement('g', {
        className: classes._root,
        style: _extends({
          opacity: hidden ? 0.5 : 1
        }, style),
        onClick: onClick
      }, _react2["default"].createElement('path', _extends({
        d: 'M' + points.map(function (c) {
          return Math.max(c[0], strokeWidth / 2) + ',' + Math.max(c[1], strokeWidth / 2);
        }).join(',') + (closePath ? 'z' : ''),
        fill: boxColor,
        fillOpacity: shadeBoxes ? 0.4 : selected ? 0.75 : 0,
        strokeWidth: strokeWidth,
        stroke: boxColor
      }, pathProps)), showCenter && center && _react2["default"].createElement('circle', {
        className: classes.circle,
        cx: center[0],
        cy: center[1],
        r: strokeWidth * 1.5,
        fill: boxColor,
        strokeWidth: strokeWidth
      }), showLabel && _react2["default"].createElement('g', {
        onClick: onClick
      }, _react2["default"].createElement('defs', null, _react2["default"].createElement('filter', {
        x: 0,
        y: 0,
        width: 1,
        height: 1,
        id: 'bg-' + boxId
      }, _react2["default"].createElement('feFlood', {
        floodColor: boxColor
      }), _react2["default"].createElement('feComposite', {
        'in': 'SourceGraphic'
      }))), _react2["default"].createElement('text', {
        className: classes.text,
        filter: 'url(#bg-' + boxId + ')',
        x: Math.max(labelPos.x, strokeWidth),
        y: Math.max(labelPos.y - strokeWidth, fontSize),
        style: {
          fontSize: fontSize
        }
      }, '\xA0', label, '\xA0')), this.props.children);
    }
  }]);

  return BoundingBox;
}(_react2["default"].Component), _class2.defaultProps = {
  hidden: false,
  points: [],
  center: null,
  showCenter: false,
  shadeBoxes: false,
  strokeWidth: 4,
  fontSize: 16,
  closePath: true,
  autoPositionLabel: false,
  i: 0,
  id: null
}, _class2.propTypes = {
  hidden: _propTypes2["default"].bool,
  points: _propTypes2["default"].array,
  center: _propTypes2["default"].array,
  showCenter: _propTypes2["default"].bool,
  shadeBoxes: _propTypes2["default"].bool,
  strokeWidth: _propTypes2["default"].number,
  fontSize: _propTypes2["default"].number,
  i: _propTypes2["default"].number
}, _temp2)) || _class);
exports["default"] = BoundingBox;